import 'core-js/fn/object/assign';
import React from 'react';
import ReactDOM from 'react-dom';
import history from './History';
import Root from './Root';
import Popup from 'react-popup';

// Render the main component into the dom
ReactDOM.render(<Root history={history} />, document.getElementById('app'));
ReactDOM.render(<Popup />, document.getElementById('popupContainer'));



// WEBPACK FOOTER //
// ./src/index.js